import { Button } from 'antd';
import PropTypes from 'prop-types';

import { isMobile } from '@vindr/utils/mobile';
import Icon from './Icon';
import Tooltip from './Tooltip';

const ToolbarButton = ({
  type = 'tool',
  id,
  icon,
  label,
  commands,
  onInteraction,
  dropdownContent,
  //
  isActive: _isActive,
  bState = {},
  //
}) => {
  const { primaryToolId } = bState;
  const isActive = _isActive || (type === 'tool' && id === primaryToolId);

  const shouldShowDropdown = !!isActive && !!dropdownContent;

  return (
    <div key={id} className="flex h-6">
      <Tooltip
        placement="bottom"
        title={
          !isMobile() ? (shouldShowDropdown ? dropdownContent : label) : ''
        }
        arrowPointAtCenter={true}
      >
        <Button
          type="link"
          className={`mx-1.5 h-6 rounded-sm p-0 outline-none `}
          onClick={() => {
            onInteraction({
              itemId: id,
              interactionType: type,
              commands,
            });
          }}
          name={label}
          key={id}
          id={id}
        >
          <Icon
            name={icon}
            className={`text-4xl hover:text-primary-light ${
              isActive ? 'text-primary-light' : 'text-white'
            }`}
          />
        </Button>
      </Tooltip>
    </div>
  );
};

ToolbarButton.defaultProps = {
  dropdownContent: null,
  isActive: false,
  type: 'action',
};

ToolbarButton.propTypes = {
  /* Influences background/hover styling */
  type: PropTypes.oneOf(['action', 'toggle', 'tool']),
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onInteraction: PropTypes.func.isRequired,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  /** Tooltip content can be replaced for a customized content by passing a node to this value. */
  dropdownContent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export default ToolbarButton;
